export default __webpack_public_path__ + "static/media/bl20.c5b9dec8.png";